import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container } from "react-bootstrap";

function SumitaOvercomingObstacles() {
  return (
    <>
      <Header />
      <main id="page-content" className="main-page">
        {/* Breadcrumbs */}
        <section
          className="position-relative text-white text-center"
          style={{ height: "400px" }}
        >
          <img
            src=""
            alt="A New Hope for Disabled Children"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
          />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

          <Container className="position-relative d-flex flex-column justify-content-center align-items-center h-100">
            <h1 className="fw-bold display-5 mb-3">
              Success Story – Sumita Sodi’s Journey with Vikash Foundation
            </h1>
          </Container>
        </section>
        <br></br>
        {/* Post Thumbnail */}
        <section className="post-thumbnail text-center">
          <img
            src="/images/story3.jpg"
            alt="Surfing man adventure"
            width={900}
            height={600}
            srcSet="
              /images/story3.jpg
            "
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </section>

        <br></br>

        <section className="container my-5">
          {/* Post Content */}
          {/* Post Content */}
          <article className="post-content">
            <p>
              Sumita Sodi, born prematurely, faced challenges from the start,
              showing little interest in activities and needing assistance with
              daily tasks. Her academic performance suffered, as she struggled
              to identify objects and maintain balance while moving around.
            </p>

            <h3>Recognizing the Challenges</h3>
            <p>
              Understanding her difficulties, Vikash Foundation intervened and
              diagnosed Sumita with <strong>mental retardation (MR)</strong>.
              Early identification helped us plan and implement the right
              support tailored to her needs.
            </p>

            <h3>Therapies and Support Provided</h3>
            <p>
              With a combination of{" "}
              <strong>
                physiotherapy, occupational therapy, special education, and
                behavioral training
              </strong>
              , Sumita began her journey towards independence. Each therapy was
              designed to enhance her physical strength, learning abilities, and
              adaptive skills.
            </p>

            <h3>Inspiring Progress</h3>
            <p>
              Today, Sumita confidently manages her daily activities on her own
              and has developed essential <strong>social skills</strong>. She
              enjoys interacting with other children and has shown steady
              improvements in her overall development.
            </p>

            <p>
              Sumita’s journey is a testament to the power of early
              intervention, dedicated care, and structured therapy programs. At
              Vikash Foundation, we remain committed to supporting children like
              Sumita in realizing their potential and leading fulfilling lives.
            </p>
          </article>
        </section>
      </main>
      <br></br>

      <Footer />
    </>
  );
}

export default SumitaOvercomingObstacles;
